module.exports = __webpack_public_path__ + "media/images/icon_send-4185d8630a7808de57240ff60e2d0214.svg";